/* Load offscreen media when it is needed, independently of analytics or consent. */
(() => {
  const hydrate = template => {
    if (!template?.isConnected) return;
    const fragment = template.content.cloneNode(true);
    const img = fragment.querySelector('img');
    const card = template.closest('.hdn-card, .card__media');
    if (img) {
      img.loading = 'eager';
      if (template.dataset.bobboImage === 'hover') {
        const ready = () => {
          if (img.naturalWidth) {
            card?.classList.add('bobbo-hover-ready', 'reference-hover-ready');
          }
        };
        img.addEventListener('load', ready, {once: true});
        if (img.complete) ready();
      }
    }
    template.parentElement.querySelector('[data-bobbo-image-placeholder]')?.remove();
    template.replaceWith(fragment);
  };
  const loadIn = element => element?.querySelectorAll('template[data-bobbo-image="viewport"]').forEach(hydrate);
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) { loadIn(entry.target); observer.unobserve(entry.target); }
    });
  }, {rootMargin: '240px 0px'}) : null;

  const initialize = () => {
    document.querySelectorAll('template[data-bobbo-image]').forEach(template => {
      if (template.dataset.observed) return;
      template.dataset.observed = 'true';
      if (template.dataset.bobboImage === 'hover') {
        const card = template.closest('.hdn-card, .card__media');
        const load = () => hydrate(template);
        const onPointerEnter = event => {
          if (event.pointerType === 'touch') return;
          load();
          card?.removeEventListener('pointerenter', onPointerEnter);
        };
        card?.addEventListener('pointerenter', onPointerEnter);
        card?.addEventListener('focusin', load, {once: true});
      } else if (observer) observer.observe(template.parentElement);
      else hydrate(template);
    });
    document.querySelectorAll('.reference-product-gallery').forEach(gallery => {
      if (gallery.dataset.imageLoader) return;
      gallery.dataset.imageLoader = 'true';
      gallery.addEventListener('pointerdown', () => {
        const index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        [index - 1, index, index + 1].forEach(i => loadIn(gallery.children[i]));
      }, {passive: true});
    });
  };
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-gallery-thumb], [data-gallery-step]');
    if (!control) return;
    const gallery = control.closest('.product__media-wrapper')?.querySelector('.reference-product-gallery');
    if (!gallery) return;
    const index = control.hasAttribute('data-gallery-thumb') ? Number(control.dataset.galleryThumb)
      : Math.round(gallery.scrollLeft / gallery.clientWidth) + Number(control.dataset.galleryStep);
    loadIn(gallery.children[index]);
  }, true);
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
